import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { planListGetData } from 'PlanListPackage/MainModule/actions/planListActions';
import {
  IPlanListFilterSetCurrentParams,
  planListFilterGetData,
  planListFilterSetCurrent,
  planListFilterSetSwitcher,
  planListFilterCreate,
  planListFilterUpdate,
  planListFilterRemove,
} from 'PlanListPackage/PlanListPanelModule/actions/planListFilterActions';

import { IKnmPlanFilter } from '../interfaces/IKnmPlanFilter';

export function usePlanListFiltersModal() {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const getPlanListData = useCallback(() => dispatch(planListGetData()), [dispatch]);
  const getPlanListFilterData = useCallback((id: IFilterResult['id']) => dispatch(planListFilterGetData(id)), [
    dispatch,
  ]);
  const setPlanListFilterCurrent = useCallback(
    (params: IPlanListFilterSetCurrentParams) => dispatch(planListFilterSetCurrent(params)),
    [dispatch],
  );
  const setPlanListFilterSwitcher = useCallback((value: boolean) => dispatch(planListFilterSetSwitcher(value)), [
    dispatch,
  ]);
  const createPlanListFilter = useCallback((data: IKnmPlanFilter) => dispatch(planListFilterCreate(data)), [dispatch]);
  const updatePlanListFilter = useCallback(
    (id: IFilterResult['id'], data: IKnmPlanFilter) => dispatch(planListFilterUpdate(id, data)),
    [dispatch],
  );
  const removePlanListFilter = useCallback((id: IFilterResult['id']) => dispatch(planListFilterRemove(id)), [dispatch]);

  return {
    getPlanListData,
    getPlanListFilterData,
    setPlanListFilterCurrent,
    setPlanListFilterSwitcher,
    createPlanListFilter,
    updatePlanListFilter,
    removePlanListFilter,
  };
}
